// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigator_nav__3PPPk","disabled":"Navigator_disabled__GJNxq"};